<template>
  <div class="myself_wrapper">

    <el-dialog :title="$t('other.a3124')" :visible.sync="dialogVisibleTwo" width="50%">
			<el-table :data="agenyList" border  style="width: 100%;" height='400'>
				<el-table-column prop="country" :label="$t('other.a3125')">
					<template slot-scope="props">
						<span>{{props.row.userId}}</span>
					</template>
				</el-table-column>
        <el-table-column prop="userName" :label="$t('other.a3126')">
					<template slot-scope="props">
						<span>{{props.row.userName}}</span>
					</template>
				</el-table-column>
        <el-table-column prop="unShipped" :label="$t('other.a761')">
					<template slot-scope="props">
						<span>{{props.row.unShipped}}</span>
					</template>
				</el-table-column>
				
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisibleTwo =false">{{$t('other.a5')}}</el-button>
			</span>
		</el-dialog>
    <el-dialog
      :title="$t('other.a3127')"
      :visible.sync="FEIXIAOshow"
      width="30%"
      :modal="false"
      center
    >
      <div>
          <el-row class="line">
            <el-col :span="6" class="select_title">{{$t('other.a3133')}}:</el-col>
            <el-col :span="14">
              {{FEIXIAOdata.desc}}
            </el-col>
          </el-row>
          <el-row class="line">
            <el-col :span="6" class="select_title">{{$t('other.a3134')}}:</el-col>
            <el-col :span="14">
              {{FEIXIAOdata.oneLevelRate}}
            </el-col>
          </el-row>
          <el-row class="line">
            <el-col :span="6" class="select_title">{{$t('other.a3135')}}:</el-col>
            <el-col :span="14">
              {{FEIXIAOdata.twoLevelRate}}
            </el-col>
          </el-row>
          <el-row class="line">
            <el-col :span="6" class="select_title">{{$t('other.a3139')}}:</el-col>
            <el-col :span="14">
              {{FEIXIAOdata.threeLevelRate}}
            </el-col>
          </el-row>
          <el-row class="line">
            <el-col :span="6" class="select_title">{{$t('other.a3136')}}:</el-col>
            <el-col :span="14">
              {{FEIXIAOdata.minimumStock}}
            </el-col>
          </el-row>
          <el-row class="line">
            <el-col :span="6" class="select_title">{{$t('other.a3137')}}:</el-col>
            <el-col :span="14">
              {{FEIXIAOdata.category}}
            </el-col>
          </el-row>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="enroll"
          >{{$t('other.a3138')}}</el-button
        >
      </span>
    </el-dialog>
    
    
    <!-- <el-button type="primary" @click="openDialog=true">新增赠品或耗材</el-button> -->
    <div class="header_top">
      <el-dialog
        :title="$t('other.a3128')"
        :visible.sync="cleanStoreDia"
        :close-on-click-modal="false"
        
        width="50%"
        >
        <div style="margin-bottom:10px">
          <p style="color:red;padding-bottom:10px">{{$t('other.a3140')}}</p>
        </div>
        <!-- <div style="margin-bottom:10px">
          设置商品毛利率(%):<el-input style="width:200px;margin-left:20px;" @blur="changePrice()" size="mini" v-model="proRate" placeholder="例：85%的毛利率,可填入85"></el-input> 
        </div> -->
        <div>
          <el-table :data="storeGoodList" border size="mini" style="width: 100%" height='400'>
            <el-table-column prop="cusCode" :label="$t('other.a67')" >
              <template slot-scope="props">
                <span>{{props.row.cusCode}}</span>
              </template>
            </el-table-column>
            <el-table-column  prop="grossProfitRate" :label="$t('other.a301')">
              <template slot-scope="props">
                <span>{{props.row.grossProfitRate}}%</span>
                <span class="jiing" v-show="props.row.grossProfitRate < 80">{{$t('other.a3141')}}</span>
              </template>
            </el-table-column>
            <el-table-column  prop="price" :label="$t('other.a3129')">
              <template slot-scope="props">
                ￥{{props.row.price}}
              </template>
            </el-table-column>
            <el-table-column   >
              <template slot-scope="scope"  slot="header">
										 <span style="padding-right:25px">{{$t('other.a3142')}}</span>
										 <el-input size="mini" style="width:100px" @blur="setPrice(1)" v-model="priceValue" :placeholder="$t('other.a307')"></el-input>
							</template>
              <template slot-scope="props">
                ￥<el-input style="width:60px;" @blur="changePrice(props.row)" size="mini" v-model="props.row.cleanprice" placeholder=""></el-input>
                <span class="jiing" v-show="props.row.cleanprice >= props.row.price*0.5">{{$t('other.a3141')}}</span>
              </template>
            </el-table-column>
            <el-table-column   :label="$t('other.a3130')">
              <template slot-scope="props">
                <span>￥{{props.row.minRmb}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="info" @click="cleanStoreDia = false">{{$t('other.a106')}}</el-button>
          <el-button type="primary" @click="updataGruop()">{{$t('other.a1907')}}</el-button>
        </span>
      </el-dialog>
      <!-- h5分享页 -->
      <el-dialog
        :title="$t('other.a3131')"
        :visible.sync="dialogVisible_h5"
        width="30%"
        >
        <div style="margin-bottom:10px">{{$t('distribution.distributionH5Link')}}: </div>
        <div style="display:flex">
          <el-input v-model="h5Url"  placeholder=""></el-input>
          <el-button style="margin-left:15px" size="mini" @click="copyUrl()" type="danger">{{$t('distribution.copy')}}</el-button>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible_h5 = false">{{$t('distribution.cancel')}}</el-button>
        </span>
      </el-dialog>

      <el-dialog
        :title="$t('distribution.deleteFileTip')"
        :visible.sync="dialogVisible"
        width="30%"
        >
        <el-table
        :data="tableData"
        border
        size="mini"
        style="width: 100%">
        <el-table-column
          prop="cusCode"
          label="cusCode"
          >
        </el-table-column>
        <el-table-column
          prop="msg"
          :label="$t('distribution.failReason')"
         >
        </el-table-column>
      </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{$t('distribution.cancel')}}</el-button>
          <el-button type="primary" @click="dialogVisible = false">{{$t('distribution.determine')}}</el-button>
        </span>
      </el-dialog>
      <!-- 一级菜单栏 -->
      <div class="query_list">
        <span :class="{item_wrapper:true,item_active:item.value == warehouseId}" v-for="(item,index) in storeList" :key="index" @click="getStoreItemAndGroup(item)">
            <span v-if="item.imgUrl" style="display:inline-block;width:20px;height:20px;overflow:hidden"><img style="width:100%" :src="item.imgUrl" /></span>
            {{item.label}}
          </span>
      </div>
      <!-- 二级菜单栏 -->
      <div class="query-list-tcp">
        <div class="query-list-bbc create">
          <el-input
            style="width: 320px; margin: 0 5px"
            clearable
            :placeholder="$t('distribution.searchStore')"
            v-model="dataParams.cusCode"
          ></el-input>
          <el-button type="primary" @click="searchProduct()">{{
            $t("userStoreItems").search
          }}</el-button>
          <el-button type="primary" @click="openFENXIAO()">{{$t('other.a3143')}}</el-button>
        </div>
        <div style="margin-right:20px;">
          <!-- <span style="font-size: 18px;margin:0 15px" >{{$t('distribution.nowSelect')}}({{ targetListCopy.length }})</span > -->
          <!-- <el-dropdown style="margin-left: 15px" type="primary">
            <el-button type="primary">
              {{$t('distribution.operationBatch')}}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                
                @click.native="massDeletd()"
                >{{$t('distribution.operationBatchDelete')}}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown> -->
          <!-- <el-button style="margin-left:20px" type="info"  @click="testByAdmin()">更新分销产品</el-button> -->
          <el-button style="margin-left:20px" type="info" @click="openGuid()">{{$t('other.a3144')}}</el-button>
          <el-button v-if="!isShopsooo"  type="primary" @click="generatelink()">{{$t('other.a3145')}}</el-button>
        </div>
      </div>
    </div>
    <!-- 产品展示列表 -->
    <div  class="overseaProduct_list">
          <div class="no_data" v-if="!overDataList.length">--{{$t('distribution.havenProduct')}}--</div>
          <div v-else :class="{'overseaProduct_item':true,'overseaProduct_item_active':activeIndex === index} " @mouseenter="activeIndex=index" @mouseleave="activeIndex=-1"   v-for="(item,index) in overDataList" :key="index" >
              <div class="pic_box"  @click="toDetail(item)">
                  <img style="width:100%;heigth:25px" :src="item.image ? item.image : item.storeItems[0].image" />
              </div>
              <div class="title_overseaProduct">{{item.groupName}}</div>
              <div class="item_desc">{{$t('distribution.mSKU')}}：{{item.itemSku}}</div>
              <div class="item_desc_parentsku" v-if="item.priceList.length == 1">{{$t('other.a219')}}：{{item.priceList[0]}}</div>
              <div class="item_desc_parentsku" v-if="item.priceList.length > 1">{{$t('other.a219')}}：{{item.priceList[0] }} ~ {{item.priceList[1]}}</div>
              <div class="item_desc">{{$t('distribution.sSKUNum')}}：{{item.storeItems.length}}</div>
              <div class="item_desc">{{$t('distribution.totalStock')}}：{{item.total}}</div>
              <div class="item_desc">
                 <div style="font-size:10px;">
                {{$t('other.a3146')}}：{{item.createTime}}
              </div>
              </div>
              <div class="update_overseaProduct">
                  <el-tooltip effect="dark" :content="item.urgent.length +$t('other.a3132')" placement="top-start">
                    <span class="usrlnk" @click="viewAgency(item)">
                      {{item.urgent.length}}
                    </span>
                    
                  </el-tooltip>
                <div>
                  <span class="btn_reverse pomo" v-show="!item.clearInWarehouse" @click="cleanStore(item,index)">{{$t('other.a3147')}}</span>  
                  <span class="btn_reverse pomoActive" v-show="item.clearInWarehouse" >{{$t('other.a3148')}}</span>  
                  <span class="btn_reverse" @click="OffShelf(item,index)">{{$t('other.a3149')}}</span>
                </div>
              </div>
          </div>
      </div>

      <div class="Pager">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10,15,20,50,100]" :page-size="dataParams.offset" layout="total, sizes, prev, pager, next, jumper" :total="overDataTotal">
      </el-pagination>
      </div>

  </div>
</template>

<script>
import TableDialog from "../../components/table.vue";
import mygoods from '../../../../api/moudles/mygoods'
import userStoreItemsApi from "../../../../api/moudles/userStoreItems";
import distributionApi from '../../../../api/moudles/distribution'
import QrcodeDialog from '../../../../components/dialog/qrcodeDialog'
import newOrders from '../../../../api/moudles/newOrders'
import utils from '../../../../utils/utils'
import { mapState, mapActions, mapMutations } from "vuex";
import config from "../../config/config";
import api from '../../../../api/api';
import { param } from '../../../../api/jsonp';
export default {
  data() {
    return {
      openDialog: false,
      shopIdInfo:JSON.parse(localStorage.getItem('shopIdInfo')),
      warehouseId: null,
      activeIndex:-1,
      TitleDesc: "",
      handleParam: null,
      cusCode: "",
      newUserstoreItem: [],
      noOnlineItem:[],
      offset: 15,
      h5Url:null,
      dialogVisible_h5:false,
      instockdia:false,
      getDataList: null,
      userName:JSON.parse(localStorage.getItem('userInfo')).userName,
      isShopsooo:JSON.parse(localStorage.getItem('isShopsooo')),
      page: 0,
      checkedAll: false,
      targetList: [],
      isExtened: false,
      isEdit: -1,
      dialogTableVisibleTwo: false,
      additionParents: [],
      isShow: false,
      isAlliance:false,
      isEditGoods: false,
      multipleSelection: [],
      lineItem:[],
      tableData:[],
      dialogVisible:false,
      cleanStoreDia:false,
      proRate:null,
      showBtn:false,
      additionItem: null,
      listErrorOptions: [],
      itemsCount:0,
      priceValue:null,
      tableList: [],
      storeGoodList:[],
      tableCount: 0,
      currentPage4: 1,
      currentPage:1,
      itemKey:0,
      page: 0,
      value: null,
      dataParams:{
        component: true,
        distribution:true,
        cusCode: "",
        offset: 50,
        page: 0,
        sellerId: JSON.parse(localStorage.getItem('userInfo')).userId,
        storeId: null,
        userId: JSON.parse(localStorage.getItem('userInfo')).userId,
    },
    overDataList:[],
    overDataTotal:0,
    targetListCopy:[],
    storeList:[],
    cleanItem:null,
    modelData:null,
    agenyList:[],
    dialogVisibleTwo:false,
    FEIXIAOshow:false,
    FEIXIAOdata:{}
    }
  },
  computed: {
    ...mapState({
      userId: (state) => state.shopaccess.userInfo.userId,
    }),
    cusCodeValue(){
      return JSON.parse(JSON.stringify(this.dataParams.cusCode))
    }


  },

  watch: {
        
        cusCodeValue(){
          if(!this.cusCodeValue){
            this.getdistrubureData(this.dataParams)
          }
        },

        dialogVisible(){
          if(!this.dialogVisible){
            this.getdistrubureData(this.dataParams)
             this.targetListCopy=[]
              this.targetList=[]
          }
        }

    },
  components: {
  
  },
  created() {
    let host=location.href
    if(host.indexOf('192.168.1.41') > -1){
      this.showBtn=true
    }

    this.warehouseId='all'
    let stores=JSON.parse(localStorage.getItem('userInfo')).stores
    this.storeList=[{
      label:this.$t('other.a1846'),
      value:'all'
    }]

    
    stores.forEach(p => {
      if(p.isUsed){
        this.storeList.push({
          value:p.storeId,
          label:p.storeName
        })
        
      }
    })
   
    this.init()
 
    
  },
  methods: {
    ...config,
    ...mapActions("userStoreItems", [
      "updateGroup",
      "sellerUpdateStoreItemDetail",
      'getInstockoperaterecore',
      'deleStoreItems'
    ]),

    viewAgency(item){
      console.log(item)
      // this.agenyList=item.storeItems[0].parents
      // this.dialogVisibleTwo=true
      this.$router.push({
        path:'/agent/hasAgentDetail',
        query:{
          productId:item.productId,
          groupId:item.groupId,
          type:1
        }
      })
    },

    cleanStore(item,index){
      console.log(item)

      let that=this
      let list=[]
      item.storeItems.forEach(p => {
          p.cleanprice=0
          list.push(that.getUrlBycusCode(p))
      })
      Promise.all(list).then((res) => {
        let onlineLink=res
        onlineLink.forEach(k => {
            k.forEach(p => {
                let shopIdInfo=this.shopIdInfo.find(item => item.shopId == p.shopId)
                p.shopIdInfo=shopIdInfo ?  shopIdInfo : null
                p.country=shopIdInfo ? shopIdInfo.country : item.country
                p.rmbList=[]
                if(shopIdInfo){
                    p.rmbList=k.map(item => utils.interestRateConversion(shopIdInfo.country,item.price))
                    if(p.rmbList){
                        p.minRmb=Math.min(...p.rmbList)
                    }else{
                        p.minRmb=this.$t("other.a354")
                    }
                }
                if(p.minRmb){
                  let ttp =item.storeItems.find(item => item.cusCode == p.cusCode)
                  ttp.minRmb=p.minRmb
                }
            })
        })

        this.getModelData(item.productId)
        this.proRate=null
        console.log(item)
        this.storeGoodList=item.storeItems
        this.cleanItem=item
        this.cleanStoreDia=true


      })
      // this.getGruopInfo(item.groupId)
      
    },

    getUrlBycusCode(params){
        return new Promise((resolve,reject) => {
            mygoods
            .getBindItems({cusCode:params.cusCode})
            .then(res => {
            if(res.code === 200 ){
                let list=null
                if(!res.data.length){
                    list=[{
                        cusCode: params.cusCode,
                        id: null,
                        image: params.image,
                        itemId: null,
                        itemKey: null,
                        itemName: null,
                        itemSku: null,
                        mainImage: params.image,
                        msg: null,
                        normal: true,
                        packageHeight: 0,
                        packageLength: 0,
                        packageWidth: 0,
                        price: 0,
                        reservedStock: 0,
                        shopId: null,
                        variationId: null,
                        variationName: null,
                        variationSku: null,
                        weight: 0
                    }]
                }else{
                    list=res.data
                }
                resolve(list)
            }else{
                reject(null)
            }
            })
        })
    },

    



    getModelData(id){
      api
      .getProductByproductId({
          productId:id
      }).then(res => {
        if(res.code == 200){
          console.log('852',res.data)
          this.modelData=res.data
        }else{
          this.$message.warning(res.msg)
        }
      })
    },

    //更新产品模版
    updataModel(params){
      this.showLoading()
        api
        .updataProduct(params)
        .then(res => {
            if(res.code === 200){
                console.log('新增模版',res.data)
                this.$message.success(this.$t('other.a3150'))
                this.isEditor=false
            }else{
                this.$message.warning(res.msg)
            }
        })
       
    },

    //更新供货商仓库产品
    updataGruop(){
      console.log(this.cleanItem)
      let list=JSON.parse(JSON.stringify(this.storeGoodList))
      let falg=false
      for (let i = 0; i < list.length; i++) {
        if(list[i].grossProfitRate < 80){
          this.$message.warning(this.$t('other.a3151'))
          falg=true
          break
        }
        if(list[i].cleanprice > list[i].price*0.5){
          this.$message.warning(this.$t('other.a3152'))
          falg=true
          break
        }
        list[i].price=list[i].cleanprice

      }

      if(falg){
        return
      }


     
      this.cleanItem.storeItems=list
      this.modelData.variations.forEach(k => {
        let newObj=list.find(item => item.cusCode == k.cusCode)
        k.price=newObj ? newObj.price : k.price
      })

      this.cleanItem.clearInWarehouse=true

      console.log(this.modelData)
      this.updataModel(this.modelData)
      distributionApi
        .putAwayToDistribution(this.cleanItem)
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.$message.success(this.$t('other.a3153'))
        
        }else{
        this.$message.warning(res.msg)
        }
        })
    },

    getCleanRate(){
      distributionApi
      .getCleanPrice(this.cleanItem)
      .then(res => {
      if(res.code === 200 ){
      console.log('desc',res.data)
      this.storeGoodList.forEach((p,index) => {
        let ttp=res.data.storeItems.find(k => k.cusCode == p.cusCode)
        p.grossProfitRate=res.data.fixGrossProfitRate
        p.cleanprice=ttp ? ttp.price : p.price
        this.$set(this.storeGoodList,index,p)
      })
      }else{
      this.$message.warning(res.msg)
      }
      })
    },

    setPrice(){

      if(isNaN(this.priceValue)){
        this.priceValue=null
        return
      }

      this.storeGoodList.forEach((p,index) => {
        p.cleanprice=Number(this.priceValue)
        this.changePrice(p)

      })

    },

    

    changePrice(item){
      if(item.cleanprice == 0){
        item.grossProfitRate=Math.round((item.minRmb-item.price)/item.minRmb*100 * 100) / 100
        return
      }
      item.grossProfitRate=Math.round((item.minRmb-item.cleanprice)/item.minRmb*100 * 100 ) /100

      // this.cleanItem.clearInWarehouse=true
      // this.cleanItem.fixGrossProfitRate=ttp
      // this.getCleanRate()
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.dataParams.offset =Number( `${val}`)
      this.handleCurrentChange()
    },
    //显示当前第几页
    handleCurrentChange(val) {
      let currentPage = (parseInt(`${val}`) - 1) * this.dataParams.offset
      this.dataParams.page=currentPage ? currentPage : 0
      this.getdistrubureData(this.dataParams)
    },

    generatePage(){
      this.$router.push({
        path:'/mh5/distributionStore',
        query:{
          userId:this.userId
        }
      })
    },

    




    OffShelf(item,index){
      let parnetList=[]
      let test=null

      item.storeItems.forEach(p => {
        p.parents.forEach(i => {
          if(parnetList.indexOf(i.userId) == -1){
            parnetList.push(i.userId)
          }
        })
      })

      if(parnetList.length > 0){
        test=this.$t('other.a3154')+parnetList.length+this.$t('other.a3155')
        this.$confirm(test, this.$t("other.a142"), {
        confirmButtonText: this.$t("other.a884"),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {})
      }else{
        test=this.$t('other.a3156')
        this.$confirm(test, this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
          item.putAway=false
          item.storeItems.forEach(p => {
              p.putAway=false
          })
          distributionApi
          .soldOutWholePsku(item)
          .then(res => {
          if(res.code === 200 ){
          this.$message.success(this.$t('other.a236'))
          let msg=this.$t('other.a3157')+item.userId +this.$t('other.a3158')+item.itemSku+this.$t('other.a3159')
          parnetList.forEach(p => {
            utils.sengMsgBySystem({
              comeFrom:'system',
              goTo:p,
              msg:msg
            })
          })
          this.overDataList.splice(index,1)
          }else{
          this.$message.warning(res.msg)
          }
          })

        })
      }

      

    },

    targetall(){
      this.overDataList.forEach(p => {
        p.checked=true
      })

      userStoreItemsApi
						.deleteGroup(this.overDataList)
						.then(res => {
							if(res.code === 200){
                let num =0
                let qty=0
                res.data.forEach(p => {
                  if(p.code == 0){
                    num++
                  }else{
                    qty++
                    this.tableData.push(p)
                  }
                })

                if(num === this.targetListCopy.length){
                  this.$message.success(this.$t('distribution.deleteSuccess'))
                  this.targetListCopy=[]
                  this.getdistrubureData(this.dataParams)
                  this.targetList=[]
                }else{
                  this.dialogVisible=true

                }
           
               
							}else{
                this.$message.warning(res.msg)
              }
						})
    },

    openGuid(){
      window.open('https://www.yuque.com/docs/share/e36a9993-d141-4e5f-be0a-92b98a89e765?#')
    },
    //获取线上链接
    getOnlineItem(list){
      let arr=[]
      list.forEach(p => {
        mygoods
        .getBindItems({
            cusCode:p.cusCode
        }).then(res => {
          if(res.code == 200){
            if(res.data.length !== 0){
              arr.push(res.data[0])
              this.lineItem.push(res.data[0])
            }else{
              this.lineItem.push({
                cusCode:p.cusCode,
                image:p.image,
                price:p.price,
                skuName:p.skuName,
                stock:p.stock,
              })
              this.noOnlineItem.push(p)
            }

            console.log('lineItem',this.lineItem)
            console.log('xg',arr)
          }
        })
        
      })

      
    },


    //更新产品模版
    updataModel(params){
        api
        .updataProduct(params)
        .then(res => {
            if(res.code === 200){
                console.log('新增模版',res.data)
                this.$message.success(this.$t('other.a3150'))
                this.isEditor=false
            }else{
                this.$message.warning(res.msg)
            }
        })
       
    },

    testByAdmin(){
      let itemkng=[]
      let obj=this.overDataList.find(item => item.groupId == 37720)
      itemkng.push(obj)

      console.log('itemkng',itemkng)

      

      itemkng.forEach(k => {
        api
        .getStoreItemByGroupId({
          groupId:k.groupId
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        let allCodeList=[]
        let newObj=res.data
        newObj.storeItems.forEach(i => {
          i.groupId=newObj.groupId
          i.productId=newObj.productId
          allCodeList.push(i)
        })

        console.log('allCodeList',allCodeList)



 


      let ProductIdList=itemkng.map(p => {
        return {
          productId:p.productId,
          groupId:p.groupId,
          itemSku:p.itemSku
        }
      })

      
       this.getOnlineItem(allCodeList)
     
      // 5秒后获取模版的信息，然后更新模版数据
      setTimeout(() => {
        let modelList=[]
        console.log('allCodeList',allCodeList)
         ProductIdList.forEach(p => {
          api
          .getProductByproductId({
              productId:p.productId
          }).then(res => {
              if(res.code == 200){
                  console.log('product',res.data)
                  if(res.data){
                    res.data.groupId=p.groupId
                    if(res.data.tiers && res.data.tiers.length > 0){
                       res.data.tiers[0].images=[]
                    }else{
                      let list=this.lineItem.map(i => {return i.skuName})
                       res.data.tiers=[{
                         images:[],
                         imagesUrl:[],
                         optionArray:list,
                         options:JSON.stringify(list),
                         name:p.itemSku
                       }]
                    }


                    if( res.data.variations.length > 0 && res.data.variations.length == allCodeList.length){
                      //产品已经全部绑定了链接
                      res.data.variations.forEach((p,index) => {
                        p.obj=allCodeList.find(item => item.productId == res.data.productId && item.skuName == p.variationSku )
                        p.cusCode=p.obj ? p.obj.cusCode : null
                        p.price=p.obj ? p.obj.price : p.price
                        p.onlineItem=this.lineItem.find(item => item.cusCode == p.cusCode)
                        p.image=p.onlineItem ? p.onlineItem.image : null
                        p.tierIndex[0]=index
                        
                        res.data.tiers[0].images[index]=p.image
                      })

                    }else if(res.data.variations.length > 0 && res.data.variations.length !== allCodeList.length){
                      //个别产品没有绑定线上链接
                      res.data.variations=this.lineItem.map((k,index) => {
                        res.data.tiers[0].images[index]=k.image
                        return {
                          cusCode:k.cusCode,
                          price:k.price,
                          onlineItem:k,
                          stock:k.stock,
                          image:k.image,
                          tierIndex:[index],
                          sequence:JSON.stringify([index]),
                          variationId:null,
                          variationSku:k.skuName,
                        }
                      })

                      res.data.tiers[0].imagesUrl=JSON.stringify(res.data.tiers[0].images)

                    }else{
                      //产品全部都没有绑定链接
                      res.data.variations=this.lineItem.map((k,index) => {
                        res.data.tiers[0].images[index]=k.image
                        return {
                          cusCode:k.cusCode,
                          price:k.price,
                          onlineItem:k,
                          stock:k.stock,
                          image:k.image,
                          tierIndex:[index],
                          sequence:JSON.stringify([index]),
                          variationId:null,
                          variationSku:k.skuName,
                        }
                      })
                      res.data.tiers[0].imagesUrl=JSON.stringify(res.data.tiers[0].images)
                    }


                    modelList.push(res.data)
                    //保存模版数据 
                    this.updataModel(res.data)
                    console.log('modelList',modelList)
                  }   
              }
          })

        })

        

      },5000)




        //9999
        }else{
        this.$message.warning(res.msg)
        }
        })
        
      })




      
     
      


      
    },

    generatelink(){

      newOrders
        .getUserInviteCode({userId:this.userId})
        .then(res => {
        if(res.code === 200 ){
        
         this.h5Url='https://' + location.host + '/mh5/distributionStore?invitationCode='+res.data.invitationCode
        window.open(this.h5Url)
        }else{
        this.$message.warning(res.msg)
        }
        })
    },

    init(){
        this.warehouseId='all'
        this.dataParams.storeId=null
        this.dataParams.isAllStore=true
        this.dataParams.allUserStoreList=JSON.parse(localStorage.getItem('userInfo')).storeIds
        this.getdistrubureData(this.dataParams)
    },

    chooseItem(item,index){
     
      let num=this.targetListCopy.findIndex(p => p.groupId == item.groupId)
      if(num == -1){
        this.targetListCopy.push(item)  
      }else{
        
        this.targetListCopy.splice(num,1)
      }
      console.log('num',num)
      console.log('targetListCopy',this.targetListCopy)
      
    },

    toDetail(item){

      if(item.storeItems){
        let list=item.storeItems.map(p => {
            return p.cusCode
        })
        let calcNum=0

        if(list){
            let arr=[]
            list.forEach(p => {
                mygoods
                .getBindItems({
                    cusCode:p
                })
                .then(res => {
                if(res.code === 200 ){
                console.log('desc',res.data)
                if(res.data){
                    res.data.forEach(p => {
                        let shopIdInfo=this.shopIdInfo.find(item => item.shopId == p.shopId)
                        p.country=item.country
                        p.rmbList=[]
                        if(shopIdInfo){
                            p.rmbList=res.data.map(item => utils.interestRateConversion(shopIdInfo.country,item.price))
                            // console.log(p.rmbList)
                            if(p.rmbList){
                                 p.minRmb=Math.min(...p.rmbList)
                            }else{
                                p.minRmb=this.$t("other.a354")
                            }
                        }
                        // console.log(6666)
                        // console.log(shopIdInfo)
                        // console.log(p.minRmb)
                        p.priceList=res.data.map(item => item.price)
                        // console.log(7777)
                        // console.log(p.priceList)
                    })
                    arr.push(...res.data)

                    if(arr.length > 0){
                        console.log('arr',arr)
                    }else{
                        
                    }
                    calcNum+=1
                    console.log('calcNum',calcNum)
                    console.log(item)
                    if(calcNum == list.length){
                    let variations= item.storeItems.map((i,index) => {
                                let ttp=arr.find(item => item.cusCode == i.cusCode)
                                console.log(666)
                                console.log(ttp)
                                console.log(i)
                                return {
                                    stock:i.stock > 0 ? i.stock : 0,
                                    shopIdInfo:ttp ? ttp.shopIdInfo : null,
                                    price:i.price.toFixed(2),
                                    image:ttp ? ttp.image : null,
                                    imageId:ttp ? ttp.imageId : null,
                                    variationSku:i.skuName,
                                    name:i.skuName,
                                    country:item.country,
                                    priceList:ttp ? Math.min(...ttp.priceList)  : 0,
                                    minRmb:ttp ? ttp.minRmb  : 0,
                                    tierIndex:[index],
                                    cusCode:i.cusCode,
                                    packageHeight:i.packageHeight,
                                    packageLength:i.packageLength,
                                    packageWidth:i.packageWidth,
                                    cost:i.cost,
                                    costCopy:null,
                                    costDesc:this.$t('other.a2495')+i.cost,
                                    weight:i.weight,
                                    fixGrossProfitRate:0,
                                    wholesalePrice:i.wholesalePrice
                                }
                            })
    
                            console.log('variations',variations)
                           
                            
    
                            localStorage.setItem('onlineItem',JSON.stringify({
                                arr:arr,
                                variations:variations,
                            }))

                            // this.$router.push({
                            //   path:'/hasAgentDetail',
                            //   query:{
                            //     groupId:item.groupId,
                            //     productId:item.productId,
                            //     type:1
                            //   }
                            // })

                            this.$router.push({
                              path:'/agent/hasAgentDetail',
                              query:{
                                productId:item.productId,
                                groupId:item.groupId,
                                type:1
                              }
                            })

                            // if(arr.length == 0){
                            //     this.$router.push({
                            //         path:'/editor',
                            //         query:{
                            //             groupId:this.$route.query.groupId,
                            //             storeId:this.ruleForm.storeId
                            //         }
                            //     })

                            //     return
                            // }
                            
                            // this.$router.push({
                            //     path:'/stockProduct/template',
                            //     query:{
                            //         groupId:this.$route.query.groupId,
                            //         type:this.$route.query.type,
                            //         storeId:this.ruleForm.storeId
    
                            //     }
                            // })
                            // console.log('arr',arr)
                
                  }

                }

                }else{
                this.$message.warning(res.msg)
                }
                })

            })

            
            


            
        }

    
        console.log('list',list)

    }else{
        this.$message.warning(this.$t('other.a2895'))
    }






      // console.log('item',item)
      // localStorage.setItem('storeItemDetail',JSON.stringify(item))

      // this.$router.push({
      //   path:'/hasAgentDetail',
      //   query:{
      //     groupId:item.groupId,
      //     productId:item.productId,
      //     type:1
      //   }
      // })

    },

    updataItem(item){
      console.log(item)
      let falg=JSON.parse(JSON.stringify(item.putAway))
      let test=item.putAway ? this.$t('distribution.confirmOffshelf') : this.$t('distribution.confirmOnshelf')
      this.$confirm(test,this.$t("other.a142"),{
            confirmButtonText:this.$t('distribution.determine'),
            cancelButtonText: this.$t('distribution.cancel'),
            type: 'warning'
        }).then(res => {
          api
          .updatePutAway({
            groupId:item.groupId,
            putAway:!item.putAway,
            userId:this.userId,
            storeId:this.warehouseId

          })
          .then(res => {
            if(res.code === 200) {
              if(!falg){
                this.$message.success(this.$t('distribution.successOnshelf'))
              }else{
                this.$message.success(this.$t('distribution.successOffShelf'))
              }

              this.getdistrubureData(this.dataParams)

              
            }else{
              this.$message.warning(res.msg)
            }
          })
        })
    },
    //获取我的供货信息
    getdistrubureData(params){
      this.showLoading()
        userStoreItemsApi
        .getStoreItem(params)
        .then(res => {
            if(res.code === 200){
                console.log('我的供货数据',res.data)
                res.data.groups.forEach(p => {
                    p.checked=false
                    p.total=0
                    p.urgent=[]
                    p.createTime=utils.renderTimeDate(p.createTime)
                    p.priceList=[]
                    p.storeItems.forEach(i  => {
                      i.cleanprice=0
                      p.total+=i.storeNum
                      if(p.priceList.indexOf(i.price) == -1){
                        p.priceList.push(i.price)
                      }
                      i.parents.forEach(i => {
                        if(p.urgent.indexOf(i.userId) == -1){
                          p.urgent.push(i.userId)
                        }
                      })
                    })

                    if(p.priceList.length > 1){
                      let list=JSON.parse(JSON.stringify(p.priceList))
                      p.priceList=[Math.min(...list),Math.max(...list)]
                    }



                })
                this.overDataList=res.data.groups
                console.log('listOdata',this.overDataList)
                this.overDataTotal=res.data.count
               
            }else{
                this.$message.warning(res.msg)
            }
        })
    },

    copyUrl(){
     
				let _input = document.createElement("input");   // 直接构建input
      　　_input.value = this.h5Url;  // 设置内容
      　　document.body.appendChild(_input);    // 添加临时实例
      　　_input.select();   // 选择实例内容
      　　document.execCommand("Copy");   // 执行复制
      　　this.$message.success(this.$t('distribution.successCopy'))
      　　document.body.removeChild(_input); // 删除临时实例
    },
    openFENXIAO(){
      newOrders.getDistribution().then(res=>{
        if(res.code == 200){
            this.FEIXIAOshow = true;
            this.FEIXIAOdata = res.data
        }else{
            this.$message.warning(res.msg);
        }
      })
    },
    enroll(){
        console.log(666)
				let desc=this.$t('other.a3161')
				this.$confirm(desc, this.$t('distribution.tip'), {
				  confirmButtonText: this.$t('distribution.determine'),
				  cancelButtonText: this.$t('distribution.cancel'),
				  type: 'warning'
					}).then(() => {
            newOrders.getUserInviteCodeByDistribution({userId:this.userId}).then(res=>{
              if(res.code == 200){
                  this.$message.success(this.$t('other.a3160'));
                  this.FEIXIAOshow = false;
              }else{
                  this.$message.warning(res.msg);
              }
            })
                
					}).catch(() => { 
                  this.FEIXIAOshow = false;        
        });
    },
    searchProduct(){
      console.log(this.dataParams)
      let params=JSON.parse(JSON.stringify(this.dataParams))

      params.offset=this.overDataTotal+1
      console.log(params)
      this.getdistrubureData(params)

    },



    getStoreItemAndGroup(item){
        this.warehouseId=item.value
      if(this.warehouseId == 'all'){
        let list=this.storeList.slice(1)
        this.dataParams.isAllStore=true
        this.dataParams.allUserStoreList=JSON.parse(localStorage.getItem('userInfo')).storeIds
        this.dataParams.storeId=null
      }else{
        utils.setDefalultStoreId(this.warehouseId)
        this.dataParams.storeId=this.warehouseId
        this.dataParams.isAllStore=false
        this.dataParams.allUserStoreList=null
      }
        this.getdistrubureData(this.dataParams)
    },



    gotoOverseaStore(){
        this.$router.push({
            path:'/overseaProduct',
            query:{
                from:'distributeStoer',
                store:this.warehouseId
            }
        })
    },
    
    massDeletd(){
				let desc=this.$t('distribution.confirmDelete')
				this.$confirm(desc, this.$t('distribution.tip'), {
				  confirmButtonText: this.$t('distribution.determine'),
				  cancelButtonText: this.$t('distribution.cancel'),
				  type: 'warning'
					}).then(() => {
						userStoreItemsApi
						.deleteGroup(this.targetListCopy)
						.then(res => {
							if(res.code === 200){
                let num =0
                let qty=0
                res.data.forEach(p => {
                  if(p.code == 0){
                    num++
                  }else{
                    qty++
                    this.tableData.push(p)
                  }
                })

                if(num === this.targetListCopy.length){
                  this.$message.success(this.$t('distribution.deleteSuccess'))
                  this.targetListCopy=[]
                  this.getdistrubureData(this.dataParams)
                  this.targetList=[]
                }else{
                  this.dialogVisible=true

                }
           
               
							}else{
                this.$message.warning(res.msg)
              }
						})
					
					})
				},

    

    // //控制每页显示订单条数
    // handleSizeChangeTwo(val) {
    //   console.log(`每页 ${val} 条`);
    //   this.offset = parseInt(`${val}`);
    //   this.getDataList.offset = parseInt(`${val}`);
    //   this.handleCurrentChange();
    // },
    // //显示当前第几页
    // handleCurrentChangeTwo(val) {
    //   console.log(`${val}`);
    //   this.resetPage();
    //   this.currentPage = parseInt(`${val}`);
    //   let ppg =
    //     `${val}` == "undefined" ? 0 : (parseInt(`${val}`) - 1) * this.offset;
    //   this.getDataList.page = ppg;
    //   this.getStoreItemAndGroup();
    // },
  },
};
</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.myself_wrapper {
  background-color: #eee;

  .Pager{
      position: fixed;
      bottom: 0;
      left: 205px;
      right: 0;
      height: 40px;
      line-height: 40px;
      background-color: #fff;
      text-align:right;
      padding: 0 20px;
    
    }

    .jiing{
      color: red;
      font-size: 10px;
      margin-left: 8px;
    }

  


  .overseaProduct_list{
        
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 53px;


        .no_data{
          text-align: center;
          width: 100%;
          margin-top: 250px;
          font-size: 18px;
          color: rgb(41, 35, 35);
        }

        
       
       

        .overseaProduct_item{
            box-sizing: border-box;
            margin: 8px 3px;
            background-color: #fff;
            border-radius: 5px;
            cursor: pointer;
            border: 1px solid #fff;
           

        }

        .overseaProduct_item_active{
          border: 1px solid #F56C6C;
         
        }



        .update_overseaProduct{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 7px 0;

          .usrlnk{
            display: inline-block;
            width: 18px;
            height: 18px;
            border-radius: 20px;
            line-height: 18px;
            text-align: center;
            padding:2px;
            color: #fff;
            font-size: 10px;
            background-color: red;

          }

          .btn{
            background-color: #F56C6C;
            border-radius: 3px;
            padding:4px 5px;
            color: #eee;
            font-size: 12px;
            font-weight: bold;
            cursor: pointer;
          }

          .btn_reverse{
             background-color: rgb(42, 165, 21);
              border-radius: 3px;
              padding:3px 6px;
              color: #eee;
              font-size: 12px;
              font-weight: bold;
              cursor: pointer;
          }

          .pomo{
            background-color: #409EFF;
            margin-right: 8px;
          }

          .pomoActive{
            background-color: #E6A23C;
            margin-right: 8px;
          }
        }
        
     


        .pic_box{
            width: 205px;
            height: 205px;
            overflow: hidden;
            border-radius: 5px;
        }
        .title_overseaProduct{
            width:148px;
            height: 1.7rem;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            overflow: hidden;
            padding: 2px;
            font-size: 12px
            
        }

        .item_desc{
          width:148px;
          height: 14px;
          overflow:hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          padding:5px 0
        }

        .item_desc_parentsku{
          color: #409EFF;
          width:148px;
          height: 14px;
          overflow:hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          padding:5px 0
        }
    }

  /deep/ .el-checkbox__inner {
    width: 20px;
    height: 20px;
  }

  /deep/ .el-checkbox__inner::after {
    height: 10px;
    left: 7px;
    width: 4px;
    font-weight: bold;
  }

  .header_top {
   
    width: 100%;
    background-color: #fff;
    z-index: 9;
    border-bottom: 1px solid #eee;

    .ijkgn{
      font-size: 22px;
      font-weight: bold;
      padding: 10px 0;
      color: #757575;
    }

    .query-list-tcp {
      display: flex;
      justify-content: space-between;
      padding: 5px 0 8px 0;
    }
    
    .query_list {
      @include flex-start();
      flex-wrap: wrap;

      .item_wrapper{
        min-width: 80px;
       
       
        display: inline-block;
        box-shadow: 0 1px 6px 0 #eee;
        border-radius: 8px;
        margin-right: 10px;
        box-sizing: border-box;
        padding: 10px;
        cursor: pointer;
        font-size: 20px;
        margin-bottom: 10px;
      }

      .item_active{
        color: #fff;
        background-color: #409eff;
      }


    }
  }

  .goodsArea {
    margin-top: 237px;
    margin-bottom: 120px;
  }

  .list-item {
    padding: 0 20px 0 0;
    margin-bottom: 10px;
    background-color: #fff;
    box-sizing: border-box;
    margin: 5px 10px;
    padding: 10px;

    .childrenItem {
      padding: 10px 0 5px 25px;
      border-bottom: 1px solid #eee;

      .goods-title-desc-wrapper {
        @include flex-between();

        .check_And_Img {
          display: flex;
        }
      }
    }

    .outPsku {
      @include flex-between();
      align-items: center;

      .outPsku_left {
        display: flex;
        align-items: center;

        .el-input {
          width: 300px;
        }

        .el-icon-edit {
          margin-left: 15px;
          cursor: pointer;
          color: #409eff;
          font-size: 18px;
        }
      }

      .outPsku_right {
        display: flex;
        align-items: center;
      }
    }

    .btn-item-desc {
      padding: 0 0 8px 0;
    }

    .outDesc {
      @include flex-between();

      .goods-pic {
        width: 80px;
        height: 80px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
.line {
  margin: 10px 0px;
}
</style>